// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3akCc","option":"styles_option__1K4CO","active":"styles_active__11Z2B"};